/**
 * Утилиты для работы с маской телефона
 */

/**
 * Форматирует номер телефона в формат +7 (___) ___-__-__
 * @param {string} value - Введенное значение
 * @returns {string} - Отформатированный номер
 */
export function formatPhoneNumber(value) {
  if (!value) return ''

  // Получаем только цифры
  const digits = value.replace(/\D+/g, '')

  // Если нет цифр, возвращаем пустую строку
  if (digits.length === 0) return ''

  let formattedValue = '+7'

  if (digits.length > 1) {
    // Добавляем скобку после кода страны
    formattedValue += ' (' + digits.substring(1, Math.min(4, digits.length))
  }

  if (digits.length > 4) {
    // Добавляем закрывающую скобку и первые три цифры номера
    formattedValue += ') ' + digits.substring(4, Math.min(7, digits.length))
  }

  if (digits.length > 7) {
    // Добавляем тире и следующие две цифры
    formattedValue += '-' + digits.substring(7, Math.min(9, digits.length))
  }

  if (digits.length > 9) {
    // Добавляем тире и последние две цифры
    formattedValue += '-' + digits.substring(9, Math.min(11, digits.length))
  }

  return formattedValue
}

/**
 * Инициализирует маску телефона для поля ввода
 * @param {HTMLInputElement} input - Поле ввода
 */
export function initPhoneMask(input) {
  if (!input) return

  // Устанавливаем плейсхолдер
  input.placeholder = '+7 (___) ___-__-__'
  input.type = 'tel'

  // Обработчик ввода
  input.addEventListener('input', function (e) {
    const formatted = formatPhoneNumber(this.value)
    this.value = formatted
  })

  // Устанавливаем начальное значение +7 при фокусе, если поле пустое
  input.addEventListener('focus', function () {
    if (!this.value) {
      this.value = '+7 ('
    }
  })

  // Проверка при потере фокуса
  input.addEventListener('blur', function () {
    if (this.value === '+7 (') {
      this.value = ''
    } else {
      // Проверяем, что номер полностью заполнен
      const digitsCount = this.value.replace(/\D+/g, '').length

      if (digitsCount > 0 && digitsCount < 11) {
        // Добавляем класс ошибки
        this.classList.add('form__input--error')

        // Проверяем, есть ли уже сообщение об ошибке
        const existingError = this.parentNode?.querySelector('.form__error')
        if (!existingError && this.parentNode) {
          const errorMessage = document.createElement('div')
          errorMessage.className = 'form__error'
          errorMessage.textContent = 'Введите полный номер телефона'
          errorMessage.setAttribute('role', 'alert')
          this.parentNode.appendChild(errorMessage)
        }
      } else if (digitsCount === 11) {
        // Убираем класс ошибки, если номер полный
        this.classList.remove('form__input--error')

        // Удаляем сообщение об ошибке, если оно есть
        const existingError = this.parentNode?.querySelector('.form__error')
        if (existingError) {
          existingError.remove()
        }
      }
    }
  })
}

/**
 * Инициализирует маску телефона для всех полей на странице
 * @param {string} selector - Селектор полей (по умолчанию все поля с type="tel")
 */
export function initPhoneMasks(selector = 'input[type="tel"], input[placeholder*="телефон" i], input[placeholder*="phone" i]') {
  const phoneInputs = document.querySelectorAll(selector)

  if (!phoneInputs.length) return

  phoneInputs.forEach((input) => {
    initPhoneMask(input)
  })
}




